import { createContext, useState, useContext, useMemo } from "react";

export type IBreadcrumbs = Record<string | "isPopulated", string | boolean>;

interface IBreadcrumbsContext {
  breadcrumbsMap: IBreadcrumbs | null;
  setBreadcrumbsMap: (paramsMap: IBreadcrumbs | null) => void;
}

const BreadcrumbsContext = createContext<IBreadcrumbsContext>(null!);

export const BreadcrumbsProvider = ({ children }: React.PropsWithChildren<{}>) => {
  const [breadcrumbsMap, setBreadcrumbsMap] = useState<IBreadcrumbs | null>(null);
  const contextValue = useMemo(() => ({ breadcrumbsMap, setBreadcrumbsMap }), [breadcrumbsMap]);

  return <BreadcrumbsContext.Provider value={contextValue}>{children}</BreadcrumbsContext.Provider>;
};

export function useBreadcrumbs() {
  const context = useContext(BreadcrumbsContext);

  return context;
}
